export const ExclusiveEmptyCard = () => {
  return (
    <div className="overflow-hidden relative rounded content-center border border-white/[10%] grid place-items-center aspect-video">
      <h2 className="text-center">Tu contenido desbloqueado aparecerá aquí</h2>
    </div>
  )
}
